import { Amplify, type ResourcesConfig } from 'aws-amplify';

export interface CognitoConfig {
  readonly region: string;
  readonly userPoolId: string;
  readonly clientId: string;
}

export function createAmplifyAuthConfig(
  config: CognitoConfig,
): ResourcesConfig | undefined {
  if (!config.region || !config.userPoolId || !config.clientId) {
    return undefined;
  }

  if (!config.userPoolId.startsWith(`${config.region}_`)) {
    throw new Error('Cognito User Pool does not belong to the configured region.');
  }

  return {
    Auth: {
      Cognito: {
        userPoolId: config.userPoolId,
        userPoolClientId: config.clientId,
      },
    },
  };
}

export function configureAmplifyAuth(config: CognitoConfig): boolean {
  const resources = createAmplifyAuthConfig(config);
  if (resources === undefined) {
    return false;
  }

  Amplify.configure(resources);
  return true;
}
